/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Configure an action on a transition.
 * 
 * The action name is gated by the same two-layer registry check the admin uses, against the
 * owner of the transition's workflow.
 * @export
 * @interface PatchedTransitionActionWriteRequest
 */
export interface PatchedTransitionActionWriteRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedTransitionActionWriteRequest
     */
    transition?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedTransitionActionWriteRequest
     */
    actionName?: string;
}

/**
 * Check if a given object implements the PatchedTransitionActionWriteRequest interface.
 */
export function instanceOfPatchedTransitionActionWriteRequest(value: object): value is PatchedTransitionActionWriteRequest {
    return true;
}

export function PatchedTransitionActionWriteRequestFromJSON(json: any): PatchedTransitionActionWriteRequest {
    return PatchedTransitionActionWriteRequestFromJSONTyped(json, false);
}

export function PatchedTransitionActionWriteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedTransitionActionWriteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'transition': json['transition'] == null ? undefined : json['transition'],
        'actionName': json['action_name'] == null ? undefined : json['action_name'],
    };
}

export function PatchedTransitionActionWriteRequestToJSON(json: any): PatchedTransitionActionWriteRequest {
    return PatchedTransitionActionWriteRequestToJSONTyped(json, false);
}

export function PatchedTransitionActionWriteRequestToJSONTyped(value?: PatchedTransitionActionWriteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transition': value['transition'],
        'action_name': value['actionName'],
    };
}

